 <div [formGroup]="form" class="form-group">

  <div [ngSwitch]="input.controlType">

    <div *ngSwitchCase="1"  style="margin-bottom: 30px;border: 1px solid;
    color: #dbdbdb;
    padding: 15px;
    text-align-last: center;">

      <div *ngIf="!input.key.includes('pic')">
      <label [attr.for]="input.key">{{input.label}}</label>
      <input class="form-control" [formControlName]="input.key" [id]="input.key" type="text">

      <label class="multifamilyButton">
        <input type="file" (change)="component.mfPhotoTaken($event, input.key + '_pic', form);onImageSelected($event, input.key)" [id]="input.key + '_pic'" />
        Picture
      </label>

      <div *ngIf="form.value[input.key + '_pic'].length > 2" style="margin-top:10px;">
        <details>
          <summary>
            <span class="fa-solid fa-camera"></span>
          </summary>
            <img [src]="form.value[input.key + '_pic']" style="max-width:95%;"/>
        </details>

      </div>

    </div>

    </div>

    <div *ngSwitchCase="2" style="margin-bottom: 30px;border: 1px solid;
    color: #dbdbdb;
    padding: 15px;
    text-align-last: center;">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" style="width: 30px; height:30px;" [formControlName]="input.key" [id]="input.key">
        <label class="form-check-label" style="line-height: 2em; margin-left: 20px;" [attr.for]="input.key">{{input.label}}</label>

        <label class="multifamilyButton">
          <input type="file" (change)="component.mfPhotoTaken($event, input.key + '_pic', form);onImageSelected($event, input.key)" [id]="input.key + '_pic'" />
          Picture
        </label>

        <div *ngIf="form.value[input.key + '_pic'].length > 2" style="margin-top:10px;">
          <details>
            <summary>
              <span class="fa-solid fa-camera"></span>
            </summary>
              <img [src]="form.value[input.key + '_pic']" style="max-width:95%;"/>
          </details>

        </div>

      </div>

    </div>

    <div *ngSwitchCase="3" style="margin-bottom: 30px;border: 1px solid;
    color: #dbdbdb;
    padding: 15px;
    text-align-last: center;">
      <label [attr.for]="input.key">{{input.label}}</label>
      <input class="form-control" [formControlName]="input.key" [id]="input.key" type="number">

      <label class="multifamilyButton">
        <input type="file" (change)="component.mfPhotoTaken($event, input.key + '_pic', form);onImageSelected($event, input.key)" [id]="input.key + '_pic'" />
        Picture
      </label>

      <div *ngIf="form.value[input.key + '_pic'].length > 2" style="margin-top:10px;">
        <details>
          <summary>
            <span class="fa-solid fa-camera"></span>
          </summary>
            <img [src]="form.value[input.key + '_pic']" style="max-width:95%;"/>
        </details>

      </div>


    </div>

    <!--
    <div *ngSwitchCase="4">
      <label [attr.for]="input.key">{{input.label}}</label>
      <select class="custom-select" [id]="input.key" [formControlName]="input.key">
        <option *ngFor="let opt of input.options" [value]="opt.key">{{opt.value}}</option>
      </select>
    </div>
-->

    <div *ngSwitchCase="4" style="margin-bottom: 30px; border: 1px solid;
    color: #dbdbdb;
    padding: 15px;
    text-align-last: center;">
      <label [attr.for]="input.key">{{input.label}}</label>
      <div class="form-check form-check-inline" *ngFor="let opt of input.options">
        <input class="form-check-input" type="radio" style="width: 30px; height:30px; " [formControlName]="input.key" [id]="input.key" [value]="opt">
        <label style="line-height: 2em;
        margin-left: 20px;" [attr.for]="opt"> {{ opt }} </label>
      </div>

      <label class="multifamilyButton">
        <input type="file" (change)="component.mfPhotoTaken($event, input.key + '_pic', form);onImageSelected($event, input.key)" [id]="input.key + '_pic'" />
        Picture
      </label>

      <div *ngIf="form.value[input.key + '_pic'].length > 2" style="margin-top:10px;">
        <details>
          <summary>
            <span class="fa-solid fa-camera"></span>
          </summary>
            <img [src]="form.value[input.key + '_pic']" style="max-width:95%;"/>
        </details>

      </div>
      <!-- <div [id]="input.key + '_picdiv' ">
      </div> -->
    </div>

    <div *ngSwitchCase="5" style="margin-bottom: 30px; border: 1px solid;
    color: #dbdbdb;
    padding: 15px;
    text-align-last: center;">
      <label [attr.for]="input.key">{{input.label}}</label>
      <textarea class="form-control" [formControlName]="input.key" [id]="input.key" rows="5"></textarea>

      <label class="multifamilyButton">
        <input type="file" (change)="component.mfPhotoTaken($event, input.key + '_pic', form);onImageSelected($event, input.key)" [id]="input.key + '_pic'" />
        Picture
      </label>

      <div *ngIf="form.value[input.key + '_pic'].length > 2" style="margin-top:10px;">
        <details>
          <summary>
            <span class="fa-solid fa-camera"></span>
          </summary>
            <img src="{{form.value[input.key + '_pic']}}" style="max-width: 95%;max-height:60%"/>
        </details>

      </div>

    </div>

  </div>

</div>
